import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'
import Link from '../../components/Link'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import AuthLayout from '../../layouts/AuthLayout'
import Step1 from './Step1'
import Step2 from './Step2'

const PatientLoginWrap = styled.div`
  margin: 2rem 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

@observer
export default class Login extends Component {
  @observable step = 1

  @action
  openNext = () => {
    this.step++
  }

  @action
  reset = () => {
    this.step = 1
  }

  render() {
    return (
      <CheckLoginStatus loggedInRedirect="/dashboard">
        <AuthLayout>
          {this.step === 1 && <Step1 onNext={this.openNext} />}
          {this.step === 2 && <Step2 onCancel={this.reset} />}
          <PatientLoginWrap>
            <Text str="prose.areYouAPatient" />&nbsp;
            <Link str="titles.clickHere" to="/patient-login" />
          </PatientLoginWrap>
          <PatientLoginWrap>
            <Link str="titles.emailSupport" href="mailto:glaucomaeyeguide@umich.edu" />
          </PatientLoginWrap>
        </AuthLayout>
      </CheckLoginStatus>
    )
  }
}





// WEBPACK FOOTER //
// ./src/pages/Login/index.js